import { findColumn, findRow } from "../../../domain/find";
import { getEditorStore } from "../../../domain/store";
import type { BlockType } from "../../../domain/types";

export function insertBlockFromPalette(blockType: BlockType): void {
  const { document, selection, insertBlock, insertRowWithBlock } =
    getEditorStore();

  if (selection.kind === "block") {
    const column = findColumn(document, selection.rowId, selection.columnId);
    const index = column
      ? column.blocks.findIndex(block => block.id === selection.blockId) + 1
      : 0;
    insertBlock(
      selection.rowId,
      selection.columnId,
      Math.max(0, index),
      blockType,
    );
    return;
  }

  if (selection.kind === "column") {
    const column = findColumn(document, selection.rowId, selection.columnId);
    insertBlock(
      selection.rowId,
      selection.columnId,
      column?.blocks.length ?? 0,
      blockType,
    );
    return;
  }

  if (selection.kind === "row") {
    const row = findRow(document, selection.rowId);
    const column = row?.columns[0];
    if (row && column) {
      insertBlock(row.id, column.id, column.blocks.length, blockType);
    }
    return;
  }

  insertRowWithBlock(document.sections.length, blockType);
}
